import React from "react";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import { DATA_DN_PAYMENT_STATUS } from "../data/options";
import { Group, Text, Button, UnstyledButton, ActionIcon } from "@mantine/core";
import { IconRefresh } from "@tabler/icons";
import _ from "lodash";
import { useTranslation } from "react-i18next";

export default function DebitNotePaymentSummary({ form, name }) {
  const [cellRender] = useCellRender();
  const dn = form.values;
  const p = dn.payment;

  const { t } = useTranslation();

  const status = DATA_DN_PAYMENT_STATUS.find(
    (s) => s.value === dn?.paymentStatus
  );

  const fields = [
    {
      title: "Payment Status",
      value: status ? (
        <Group>
          {cellRender.Order.status(dn?.paymentStatus)}
          {status?.label}
        </Group>
      ) : (
        "Unknown"
      ),
    },
    {
      title: "Client Payable",
      value:
        dn?.clientPayable != null
          ? cellRender.Currency(dn.clientPayable)
          : "-",
    },
    {
      title: "Paid Amount",
      value: (
        <Text
          color={
            p?.amount != null &&
            dn?.clientPayable != null &&
            p.amount < dn.clientPayable
              ? "red"
              : "green"
          }
        >
          {p?.amount != null ? cellRender.Currency(p.amount) : "-"}
        </Text>
      ),
    },
    {
      title: "Remaining Amount",
      value: (
        <Text>
          {p?.amount != null && dn?.clientPayable != null
            ? cellRender.Currency(_.round(dn.clientPayable - p.amount, 2))
            : "-"}
        </Text>
      ),
    },
  ];

  return (
    dn && (
      <>
        <InfoGridList fields={fields} values={dn} cols={4} />

        <UnstyledButton onClick={() => form.reload()} mt="xl">
          <Group spacing={"xs"}>
            <ActionIcon>
              <IconRefresh size={"1rem"} />
            </ActionIcon>
            <Text size={"xs"}>{t("Refresh")}</Text>
          </Group>
        </UnstyledButton>
      </>
    )
  );
}
